module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/hospital_detail/logo_mrso-e088f260bf3dc5d8a188135db0b41d2c.svg";